import { CircleProgressComponentModule } from './../../components/circle-progress/circle-progress.module';
import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { MenuPage } from './menu';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    MenuPage
  ],
  imports: [
    IonicPageModule.forChild(MenuPage),
    CircleProgressComponentModule,
    TranslateModule.forChild()
  ],
  exports: [
    MenuPage
  ]
})
export class MenuPageModule {}



// WEBPACK FOOTER //
// ./src/pages/menu/menu.module.ts